<template>
  <div class="base-checkbox-container">
    <input
      id="base-checkbox"
      type="checkbox"
      :checked="props.checked"
      :disabled="props.disabled"
      class="base-checkbox"
      @change="update"
    />
    <label
      v-if="props.label"
      for="base-checkbox"
      class="base-checkbox-label">{{ props.label }}</label>
  </div>
</template>

<script setup lang="ts">
interface Props {
  checked: boolean;
  disabled: boolean;
  type: 'base' | 'close';
  label: string;
}

const props = withDefaults(defineProps<Props>(), {
  checked: false,
  disabled: false,
  type: 'base',
  label: '',
});

const emit = defineEmits(['update:checked']);

const update = (event: Event) => {
  emit('update:checked', (event.target as HTMLInputElement).checked);
};
</script>

<style scoped>
.base-checkbox-container {
  @apply inline-flex justify-center items-center w-6 h-6 rounded-md border border-transparent transition-all duration-300;
}

.base-checkbox {
  @apply w-5 h-5 rounded-md text-neutral-100 border-neutral-100 focus:ring-0 focus:ring-offset-0 transition-all duration-300 cursor-pointer;
}

.base-checkbox-label {
  @apply text-xs font-medium text-neutral-125 dark:text-gray-300 cursor-pointer;
}

.base-checkbox:disabled {
  @apply opacity-30 cursor-not-allowed;
}

.base-checkbox-container:has(.base-checkbox:not(:disabled)) {
  @apply hover:border-neutral-100 cursor-pointer;
}
</style>